var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPropertyIconVilla(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(499 773)",
    fill: "red"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-499 -773)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.649,2a.643.643,0,0,0-.255.058.615.615,0,0,0-.207.154L6.093,5.756a.575.575,0,0,0-.143.378V9.088H4.713V7.316A.577.577,0,0,0,4.532,6.9L3.294,5.717a.622.622,0,0,0-.205-.13.645.645,0,0,0-.242-.043.634.634,0,0,0-.428.173L1.181,6.9A.577.577,0,0,0,1,7.316V17.358H18.326V7.316a.577.577,0,0,0-.181-.418L16.908,5.717a.64.64,0,0,0-.875,0L14.795,6.9a.578.578,0,0,0-.181.418V9.088H13.376V6.135a.575.575,0,0,0-.143-.378L10.139,2.212a.616.616,0,0,0-.22-.16A.644.644,0,0,0,9.649,2Zm.014,1.514,2.475,2.836V9.088H10.9V7.907a1.239,1.239,0,0,0-2.475,0V9.088H7.188V6.349ZM2.856,6.97l.619.591V9.679a.577.577,0,0,0,.181.418.634.634,0,0,0,.438.173H15.232a.634.634,0,0,0,.438-.173.577.577,0,0,0,.181-.418V7.561l.619-.591.619.591v8.615h-4.95V13.814a2.478,2.478,0,0,0-4.95,0v2.363H2.238V7.561Zm1.856,5.662v2.363H5.95V12.632Zm4.95,0A1.2,1.2,0,0,1,10.9,13.814v2.363H8.426V13.814A1.2,1.2,0,0,1,9.663,12.632Zm3.713,0v2.363h1.238V12.632Z",
    transform: "translate(499.337 773.321)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyIconVilla);
export default __webpack_public_path__ + "static/media/property-icon-villa.203b85c0730bec302da548a53e08e6e5.svg";
export { ForwardRef as ReactComponent };